import { render, staticRenderFns } from "./ChatwootHistoryView.vue?vue&type=template&id=49274c82&scoped=true&"
import script from "./ChatwootHistoryView.vue?vue&type=script&lang=js&"
export * from "./ChatwootHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./ChatwootHistoryView.vue?vue&type=style&index=0&id=49274c82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49274c82",
  null
  
)

export default component.exports